import Flow from 'types/Flow';
import FlowsByModel from 'types/FlowsByModel';
import { PartteamModel } from 'types/KioskTypes';
import { SelfServiceSteps } from 'modules/selfServices/types/SelfServiceSteps';

import { BASKET } from '../home';
import { CommonOnSiteKioskCheckInSteps } from '../onSite';
import { FINAL_INSTRUCTIONS, PARTTEAM_KEY, SIGNATURE } from '../../common';
import { COMMON_KIOSK_CHECK_IN_STEPS, COMMON_KIOSK_VEHICLE_CHECK_QR_CODE } from './common';

type PartteamKioskCheckInSteps =
  CommonOnSiteKioskCheckInSteps
  | SelfServiceSteps.SIGNATURE
  | SelfServiceSteps.PARTTEAM_KEY
  | SelfServiceSteps.VEHICLE_CHECK_QR_CODE
  | SelfServiceSteps.FINAL_INSTRUCTIONS;

const flow: Flow<PartteamKioskCheckInSteps> = {
  ...COMMON_KIOSK_CHECK_IN_STEPS,
  SIGNATURE: {
    ...SIGNATURE,
    previous: BASKET.key,
    next: PARTTEAM_KEY.key,
    data: {
      ...SIGNATURE.data,
      isFinalizeStep: true,
    },
  },
  PARTTEAM_KEY: {
    ...PARTTEAM_KEY,
    previous: SIGNATURE.key,
    next: COMMON_KIOSK_VEHICLE_CHECK_QR_CODE.key,
  },
  VEHICLE_CHECK_QR_CODE: { ...COMMON_KIOSK_VEHICLE_CHECK_QR_CODE, previous: PARTTEAM_KEY.key },
  FINAL_INSTRUCTIONS: { ...FINAL_INSTRUCTIONS, previous: COMMON_KIOSK_VEHICLE_CHECK_QR_CODE.key },
};

const PARTTEAM_KIOSK_CHECK_IN_STEPS: FlowsByModel<PartteamModel> = {
  [PartteamModel.INDOOR]: flow,
  [PartteamModel.OUTDOOR]: flow,
};

export default PARTTEAM_KIOSK_CHECK_IN_STEPS;
